<template>
  <el-dialog
    title="商品分组设置"
    :visible.sync="visible"
    width="600px"
    append-to-body
    :close-on-press-escape="false"
    @closed="handleClose">
    <el-table
      border
      :data="list">
      <el-table-column label="分组名称">
        <template slot-scope="{row, $index}">
          {{ row.groupName }}
          <el-popover
            v-model="row.visible"
            placement="top"
            width="300"
            @show="() => { onShow(row, $index) }"
            @hide="() => { onHide() }">
            <el-form
              ref="ruleForm0"
              :model="ruleForm"
              :rules="rules"
              label-width="100px">
              <el-form-item
                label="分组名称："
                prop="groupName">
                <el-input v-model="ruleForm.groupName"></el-input>
              </el-form-item>
              <el-form-item
                label="排序值："
                prop="sortNumber">
                <el-input-number
                  v-model="ruleForm.sortNumber"
                  :precision="0"
                  :min="0"></el-input-number>
              </el-form-item>
            </el-form>
            <div style="text-align: right; margin: 0">
              <el-button
                size="mini"
                type="text"
                @click="row.visible = false">取消</el-button>
              <el-button
                type="primary"
                size="mini"
                @click="updategroup(row, $index)">确定</el-button>
            </div>
            <i
              slot="reference"
              class="el-icon-edit"></i>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        label="排序值"
        width="90"
        :resizable="false"
        prop="sortNumber">
      </el-table-column>
      <el-table-column
        label="创建时间"
        width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.createdTime | dateformat() }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="90">
        <template slot-scope="{row}">
          <el-button
            type="text"
            @click="deletegroup(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer">
      <el-popover
        v-model="addPopover"
        placement="top"
        width="300"
        @hide="() => { onHide() }">
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          label-width="100px">
          <el-form-item
            label="分组名称："
            prop="groupName">
            <el-input v-model="ruleForm.groupName"></el-input>
          </el-form-item>
          <el-form-item
            label="排序值："
            prop="sortNumber">
            <el-input-number
              v-model="ruleForm.sortNumber"
              :precision="0"
              :min="0"></el-input-number>
          </el-form-item>
        </el-form>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="addPopover = false">取消</el-button>
          <el-button
            type="primary"
            size="mini"
            @click="addgroup">确定</el-button>
        </div>
        <el-button
          slot="reference"
          type="primary"
          :loading="loading">新 增</el-button>
      </el-popover>
      <el-button
        style="margin-left: 10px;"
        :loading="loading"
        @click="toggleModal(false)">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ProductGroupModal',
  components: {},
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      addPopover: false,
      updatePopover: false,
      ruleForm: {
        groupName: '',
        sortNumber: 0
      },
      rules: {
        groupName: [
          { required: true, message: '请输入分组名称', trigger: 'blur' }
        ],
        sortNumber: [
          { required: true, message: '请输入排序值', trigger: 'blur' }
        ]
      },
      list: [],
      config: {
        pageNum: 1,
        pageSize: 100
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      this.callback && this.callback()
    },
    onShow(row, $index) {
      this.ruleForm.groupName = row.groupName
      this.ruleForm.groupId = row.groupId
      this.ruleForm.sortNumber = row.sortNumber
      row.visible = true
      this.$set(this.list, $index, row)
    },
    onHide() {
      this.ruleForm.groupName = ''
      this.ruleForm.groupId = null
    },
    addgroup() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('productgroup/addgroup', {
            payload: {
              ...this.ruleForm,
              groupName: this.ruleForm.groupName,
              vendorId: this.userInfo.vendorId
            },
            success: () => {
              this.loading = false
              this.addPopover = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    updategroup(row, $index) {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('productgroup/updategroup', {
            payload: {
              ...this.ruleForm,
              groupName: this.ruleForm.groupName,
              groupId: this.ruleForm.groupId,
              vendorId: this.userInfo.vendorId
            },
            success: () => {
              this.loading = false
              row.visible = false
              this.$set(this.list, $index, row)
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    deletegroup(row) {
      this.$confirm('您确定删除该分组?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('productgroup/deletegroup', {
            payload: {
              groupId: row.groupId,
              vendorId: this.userInfo.vendorId
            },
            success: () => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('productgroup/getgroups', {
        payload: {
          ...this.config,
          groupId: 0,
          vendorId: this.userInfo.vendorId
        },
        success: res => {
          this.loading = false
          this.list = res.data.records.map(i => {
            i.visible = false
            return i
          })
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleSubmit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('settings/configgiftcard', {
            payload: {
              vendorId: this.userInfo.vendorId,
              status: this.form.status,
              giftCards: this.form.imageList.map(i => {
                return {
                  cardImage: i.url,
                  giftCardId: i.giftCardId
                }
              })
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    getsetting() {
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
